<template>
  <div class="attendance-detail">
    <div class="close" @click="close">
      <mu-icon value="close" :size="64"></mu-icon>
    </div>
    <mu-paper :z-depth="1">
      <mu-data-table
        :columns="columns"
        :data="list"
        stripe
        class="table"
        :loading="loading"
        border
      >
        <template slot="header" slot-scope="scope">
          <tr>
            <th rowspan="2" class="is-center">姓名</th>
            <th
              colspan="2"
              v-for="(item, index) in scheduleList"
              :key="index"
              class="is-center"
            >
              {{ item.name }} {{ item.startTime }} - {{ item.endTime }}
            </th>
          </tr>
          <tr>
            <th
              class="is-center"
              v-for="(item, index) in scope.columns.filter(
                (item, index) => index > 0
              )"
              :key="index"
            >
              {{ item.title }}
            </th>
          </tr>
        </template>
        <template slot-scope="scope">
          <td class="is-center">{{ scope.row.user.realName }}</td>
          <td
            v-for="(item, index) in scope.row.attendance"
            :key="index"
            :class="['is-center', { red: item.second > 0 }]"
          >
            <div class="td-content">
              <div class="time">
                {{ item.time }}
              </div>
              <div class="tooltip" v-if="item.second > 0">
                {{ item.text }}{{ parseInt(item.second / 60) }}分钟
              </div>
            </div>
          </td>
        </template>
      </mu-data-table>
    </mu-paper>
  </div>
</template>

<script>
import moment from 'moment'
import backend from 'utils/backend'
import api from '@/api'
export default {
  props: {
    scheduleList: {
      type: Array
    },
    getData: {
      type: Boolean
    }
  },
  data() {
    return {
      userList: [],
      list: [],
      loading: false,
      columns: [
        {
          title: '姓名'
        }
      ]
    }
  },
  methods: {
    columnsInit() {
      this.scheduleList.forEach((item) => {
        this.columns.push({
          title: '上班'
        })
        this.columns.push({
          title: '下班'
        })
      })
    },
    getAllClerk() {
      backend(api.daka.getClerk, { getAll: true, isClerk: true }).then(
        (result) => {
          if (result.statusCode === 200) {
            this.userList = result.data.rows
          }
        }
      )
    },
    getToday() {
      this.list = []
      const list = []
      backend(api.daka.getToday).then((result) => {
        if (result.statusCode === 200) {
          this.userList.forEach((user) => {
            const temp = {
              user,
              attendance: []
            }
            this.scheduleList.forEach((schedule) => {
              const exist = result.data.find(
                (x) => x.user.id === user.id && x.schedule.id === schedule.id
              )
              temp.attendance.push({
                time:
                  exist && exist.startTime
                    ? moment(exist.startTime).format('HH:mm')
                    : '',
                second: exist ? exist.delaySecond : 0,
                text: '迟到'
              })
              temp.attendance.push({
                time:
                  exist && exist.endTime
                    ? moment(exist.endTime).format('HH:mm')
                    : '',
                second: exist ? exist.advanceSecond : 0,
                text: '早退'
              })
            })
            list.push(temp)
          })
          this.list = list
        }
      })
    },
    close() {
      this.$emit('update:getData', false)
    }
  },
  mounted() {
    this.getAllClerk()
  },
  watch: {
    scheduleList(val) {
      if (val.length > 0) {
        this.columnsInit()
      }
    },
    getData(val) {
      if (val) {
        this.getToday()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.attendance-detail {
  padding: 30px;
  position: relative;
  .close {
    position: absolute;
    top: 30px;
    right: 30px;
    color: #ff4081;
  }
  .table {
    margin-top: 80px;
    td {
      &.red {
        color: #ff4081;
      }
      .td-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .tooltip {
          width: 100px;
          height: 20px;
          text-align: center;
          background: rgba(0, 0, 0, 0.3);
          border-radius: 4px;
          color: #fff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/admin/attendance-detail.vue